import React from 'react';
import { PopupContentWrapper } from '../../../../components';
import { ErrorText, ErrorTitle } from './connected';

export const Error = () => (
  <PopupContentWrapper>
    <ErrorTitle />
    <ErrorText />
  </PopupContentWrapper>
);
